// extracted by mini-css-extract-plugin
export default {"descriptionLine":"confirm-add-backup-service-modal__description-line__te41v"};